/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import {
  Div,
} from 'konsys-ui'
import {
  Box,
  Label,
  TextLabel,
  TextValue,
  SummaryBox,
  RowHeader,
  Header,
  SubHeader,
  Row,
  Divider,
  ButtonEdit,
  IconEdit,
  SectionDiv,
  ItemDiv,
  ContentDiv,
  TextUnit,
} from './styled'
import TabSummary from '../../../../../components/common/tab-summary'
import EditIcon from '../../../../../images/icon/EditIcon.png'


const Summary = ({
  formValues,
  activeTab,
  onChangeTab,
  sticky,
  step,
  setStep,
  isSummaryInProfile,
  isFixedPosition,
  isNotTop = true,
  ContentRef,
  isOne,
  setSummaryActive,
}) => (
  <Box sticky={sticky} isSummaryInProfile={isSummaryInProfile} isFixedPosition={isFixedPosition} isNotTop={isNotTop}>
    <TabSummary
      onChange={onChangeTab}
      data={formValues.partData && formValues.partData}
      handleChangeTap={onChangeTab}
      activeTab={activeTab}
      sticky={sticky}
      ContentRef={ContentRef}
      isOne={isOne}
    >
      <Div display='flex' flexDirection='column'>
        <RowHeader>
          <Row>
            <Header>{formValues.partData[activeTab].packageData ? formValues.partData[activeTab].packageData.name : '-' }</Header>
          </Row>
          <Row>
            <SubHeader>{formValues.partData[activeTab].packagePartName ? formValues.partData[activeTab].packagePartName : formValues.partData[activeTab].packagePartName || '-' }</SubHeader>
          </Row>
          <Divider/>
        </RowHeader>
        <SummaryBox>
          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>ขนาดบรรุจุภัณฑ์</Label>
          </SectionDiv>
          <ContentDiv display='flex' flexDirection='column' >
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('a') && formValues.partData[activeTab].sizeList.a >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                <TextLabel>ความยาวด้าน A</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.a) ? formValues.partData[activeTab].sizeList.a : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('b') && formValues.partData[activeTab].sizeList.b >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน B</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.b) ? formValues.partData[activeTab].sizeList.b : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('c') && formValues.partData[activeTab].sizeList.c >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน C</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.c) ? formValues.partData[activeTab].sizeList.c : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('d') && formValues.partData[activeTab].sizeList.d >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน D</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.d) ? formValues.partData[activeTab].sizeList.d : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('e') && formValues.partData[activeTab].sizeList.e >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน E</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.e) ? formValues.partData[activeTab].sizeList.e : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('f') && formValues.partData[activeTab].sizeList.f >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน F</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.f) ? formValues.partData[activeTab].sizeList.f : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('g') && formValues.partData[activeTab].sizeList.g >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน G</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.g) ? formValues.partData[activeTab].sizeList.g : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('h') && formValues.partData[activeTab].sizeList.h >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน H</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.h) ? formValues.partData[activeTab].sizeList.h : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('i') && formValues.partData[activeTab].sizeList.i >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน I</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.i) ? formValues.partData[activeTab].sizeList.i : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
            {
              (formValues.partData[activeTab].sizeList.hasOwnProperty('j') && formValues.partData[activeTab].sizeList.j >= 0) && <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>ความยาวด้าน J</TextLabel>
                <TextValue>{ _.isNumber(formValues.partData[activeTab].sizeList.j) ? formValues.partData[activeTab].sizeList.j : '-' } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
              </ItemDiv>
            }
          </ContentDiv>

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>ประเภทกระดาษ</Label>
            <TextValue>{ formValues.partData[activeTab].paper.name || '-' }</TextValue>
          </SectionDiv>
          <ContentDiv display='flex' flexDirection='column' >
            <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
              <TextLabel>ความหนากระดาษ</TextLabel>
              <TextValue>{ formValues.partData[activeTab].paper.selectedThickness || 0} <TextUnit>แกรม</TextUnit></TextValue>
            </ItemDiv>
          </ContentDiv>

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>การพิมพ์ลวดลาย</Label>
            <TextValue>{ formValues.partData[activeTab].printing.printingName || 'ไม่พิมพ์ลวดลาย' }</TextValue>
          </SectionDiv>
          {
            formValues.partData[activeTab].printing.printingId > 0 && <ContentDiv display='flex' flexDirection='column' >
              <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                <TextLabel>ลักษณะการพิมพ์</TextLabel>
                <TextValue>{ formValues.partData[activeTab].printing.printingTypeName || '-' }</TextValue>
              </ItemDiv>
              <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                <TextLabel>รูปแบบสีการพิมพ์</TextLabel>
                <TextValue>{ formValues.partData[activeTab].printing.printingBasicColorName || '-' }</TextValue>
              </ItemDiv>
              { formValues.partData[activeTab].printing.printingExtraColorId && formValues.partData[activeTab].printing.printingExtraColorId.map((item, index) => (
                <ItemDiv key={index} display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                  <TextLabel>สีพิเศษ {index + 1}</TextLabel>
                  <TextValue>{ item.printingExtraColorName || '-' }</TextValue>
                </ItemDiv>
              ))}
            </ContentDiv>
          }

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>การเคลือบผิว</Label>
            <TextValue>{ formValues.partData[activeTab].coating.coatingType || '-' }</TextValue>
          </SectionDiv>
          {
            formValues.partData[activeTab].coating.coatingType !== 'ไม่เคลือบ' && <ContentDiv display='flex' flexDirection='column' >
              {
                formValues.partData[activeTab].coating.coatingType === 'เคลือบสองหน้า' && <ItemDiv display='flex' flexDirection='column' >
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>การเคลือบด้านหน้า</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].coating.coatingFrontName || '-' }</TextValue>
                  </ItemDiv>
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                    <TextLabel>การเคลือบด้านหลัง</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].coating.coatingBackName || '-' }</TextValue>
                  </ItemDiv>
                </ItemDiv>
              }
              {
                formValues.partData[activeTab].coating.coatingType === 'เคลือบด้านหน้า' && <ItemDiv display='flex' flexDirection='column' >
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>การเคลือบด้านหน้า</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].coating.coatingFrontName || '-' }</TextValue>
                  </ItemDiv>
                </ItemDiv>
              }
              {
                formValues.partData[activeTab].coating.coatingType === 'เคลือบด้านหลัง' && <ItemDiv display='flex' flexDirection='column' >
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>การเคลือบด้านหลัง</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].coating.coatingBackName || '-' }</TextValue>
                  </ItemDiv>
                </ItemDiv>
              }
            </ContentDiv>
          }

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>การเคลือบยูวีเฉพาะจุด</Label>
            <TextValue>{ formValues.partData[activeTab].spotUV.spotUVType || '-' }</TextValue>
          </SectionDiv>
          {
            formValues.partData[activeTab].spotUV.spotUVType !== 'ไม่เคลือบ' && <ContentDiv display='flex' flexDirection='column' >
              {
                formValues.partData[activeTab].spotUV.spotUVType === 'เคลือบสองหน้า' && <ItemDiv display='flex' flexDirection='column' >
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>การเคลือบด้านหน้า</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].spotUV.spotUVFrontName || '-' }</TextValue>
                  </ItemDiv>
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                    <TextLabel>การเคลือบด้านหลัง</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].spotUV.spotUVBackName || '-' }</TextValue>
                  </ItemDiv>
                </ItemDiv>
              }
              {
                formValues.partData[activeTab].spotUV.spotUVType === 'เคลือบด้านหน้า' && <ItemDiv display='flex' flexDirection='column' >
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>การเคลือบด้านหน้า</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].spotUV.spotUVFrontName || '-' }</TextValue>
                  </ItemDiv>
                </ItemDiv>
              }
              {
                formValues.partData[activeTab].spotUV.spotUVType === 'เคลือบด้านหลัง' && <ItemDiv display='flex' flexDirection='column' >
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>การเคลือบด้านหลัง</TextLabel>
                    <TextValue>{ formValues.partData[activeTab].spotUV.spotUVBackName || '-' }</TextValue>
                  </ItemDiv>
                </ItemDiv>
              }
            </ContentDiv>
          }

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>การปั๊มนูน</Label>
            <TextValue>{ formValues.partData[activeTab].embossing.length > 0 ? 'ใช้บริการ' : 'ไม่ใช้บริการ' }</TextValue>
          </SectionDiv>
          { formValues.partData[activeTab].embossing.length > 0 && <ContentDiv display='flex' flexDirection='column'>
              { formValues.partData[activeTab].embossing.map((item, index) => (
                <ItemDiv key={index} display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: index > 0 && '4px' }}>
                  <TextLabel>ตำแหน่งที่ {index + 1}</TextLabel>
                  <TextValue>{ `${item.width || '-'}x${item.lengths || '-'}` } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
                </ItemDiv>
              ))}
            </ContentDiv>
          }

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>การปั๊มฟอยล์-ทองเค</Label>
            <TextValue>{ formValues.partData[activeTab].foilingName || 'ไม่ใช้บริการ' }</TextValue>
          </SectionDiv>
          { formValues.partData[activeTab].foiling.length > 0 && <ContentDiv display='flex' flexDirection='column'>
              { formValues.partData[activeTab].foiling.map((item, index) => (
                <ItemDiv key={index} display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: index > 0 && '4px' }}>
                  <TextLabel>ตำแหน่งที่ {index + 1}</TextLabel>
                  <TextValue>{ `${item.width || '-'}x${item.lengths || '-'}` } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
                </ItemDiv>
              ))}
            </ContentDiv>
          }

          <SectionDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
            <Label>การเจาะหน้าต่างและติดแผ่นใส</Label>
            <TextValue>{ formValues.partData[activeTab].plasticWindow.length > 0 ? 'ใช้บริการ' : 'ไม่ใช้บริการ' }</TextValue>
          </SectionDiv>
          { formValues.partData[activeTab].plasticWindow.length > 0 && <ContentDiv display='flex' flexDirection='column'>
              { formValues.partData[activeTab].plasticWindow.map((item, index) => (
                <ItemDiv key={index} style={{ marginTop: index > 0 && '4px' }}>
                  <ItemDiv display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>
                    <TextLabel>ตำแหน่งที่ {index + 1}</TextLabel>
                    <TextValue>{ `${item.width || '-'}x${item.lengths || '-'}` } <TextUnit>{ formValues.partData[activeTab].measurementUnit.label }</TextUnit></TextValue>
                  </ItemDiv>
                  <ItemDiv key={index} display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' style={{ marginTop: '4px' }}>
                    <TextLabel></TextLabel>
                    <TextValue><TextLabel>ความหนา</TextLabel> { item.thickness || '-' } </TextValue>
                  </ItemDiv>
                </ItemDiv>
              ))}
            </ContentDiv>
          }
        </SummaryBox>
      </Div>
      {
        step === 2 && <Div display="flex" justifyContent="center" alignItems="center" style={{ marginTop: '24px' }}>
          <ButtonEdit
            text={<React.Fragment><IconEdit src={EditIcon}/>แก้ไขข้อมูล</React.Fragment>}
            inverse
            small
            onClick={async () => {
              const element = document.getElementById('content-package')
              if (element) {
                setTimeout(async () => {
                  await setStep(1)
                  await setSummaryActive()
                  await element.scrollIntoView({
                    behavior: 'smooth',
                  })
                }, 500)
              }
            }}
          />
        </Div>
      }
    </TabSummary>
  </Box>
)


export default Summary



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/summary/index.jsx